// ----------------------------------------------------------------------

const account = {
  displayName: 'Jaydon Frankie',
  email: 'demo@Assymblys.cc',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg',
};

export default account;
